import { useCallback, useMemo, useState } from 'react'
import useSettingsConnections from '@/hooks/useSettingsConnections'
import { useConnectionRowMenuActions } from './useConnectionRowMenuActions'

export function useConnectionsDirectoryModel() {
  const [query, setQuery] = useState('')
  const { connections = [], refetch } = useSettingsConnections()
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [menuRowId, setMenuRowId] = useState(null)
  const filteredConnections = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return connections
    return connections.filter(
      (row) =>
        row.title.toLowerCase().includes(q) ||
        row.email.toLowerCase().includes(q) ||
        row.toolkitSlug.toLowerCase().includes(q),
    )
  }, [connections, query])
  const handleOpenRowMenu = useCallback((event, rowId) => {
    event.stopPropagation()
    setMenuAnchor(event.currentTarget)
    setMenuRowId(rowId)
  }, [])
  const handleCloseRowMenu = useCallback(() => {
    setMenuAnchor(null)
    setMenuRowId(null)
  }, [])
  const handleRowMenuSelect = useConnectionRowMenuActions({ menuRowId, connections, refetch })
  return {
    query,
    setQuery,
    filteredConnections,
    listEmpty: connections.length === 0,
    searchNoHits: connections.length > 0 && filteredConnections.length === 0,
    menuAnchor,
    menuRowId,
    handleOpenRowMenu,
    handleCloseRowMenu,
    handleRowMenuSelect,
  }
}
